import { BaseModel } from "sjs-base-model";

export default class RichiestaDatiRedditoRequestModel extends BaseModel {
    public readonly certificatoPensione?: number = undefined;
    public readonly codiceSedePensione?: string = undefined;
    public readonly codiceCategPensione?: string = undefined;
    public readonly tfrMaturato?: number = undefined;
    public readonly tfrDataRiferimento?: string = undefined;
    public readonly tfrFondo?: number = undefined;
    public readonly tfrFondoDataRiferimento?: string = undefined;
    public readonly idFondo?: string = undefined;
    public readonly descrizioneFondo?: string = undefined;
    public readonly numeroCedolino?: number = undefined;
    public readonly meseRetribuzione?: string = undefined;
    public readonly redditoAnnuo?: number = undefined;
    public readonly altriRedditiNucleoFam?: number = undefined;
    public readonly codTipoRichiedente: string = "";
    public readonly isSospensione: boolean = false;
    public readonly idRichiesta: number = 0;
    public readonly step: string = "";
    public readonly speseAffittoAnnue?: number = undefined;
    public readonly totaleRedditoAnnuo?: number = undefined;
    public readonly altreRateizzazioniAnnue?: number = undefined;
    public readonly nettoMesile?: number = undefined;
    public readonly altriRedditiRichiedente?: number = undefined;
    public readonly fgDichiarazione: boolean = false;
    public readonly isFabbricati: boolean = false;
    public readonly numeroFabbricati: string = "";
    public readonly destinazioneFabbricati: string = "";
    public readonly isTerreni: boolean = false;
    public readonly numeroTerreni: string = "";
    public readonly destinazioneTerreni: string = "";
    // public readonly fgFinanziamentiInCorso: boolean= false;
    // public readonly rataFinanziamento: string = "";
    // public readonly finanziatore: string = "";
    // public readonly dataInizioFinanziamento: string = "";
    // public readonly rateResidueFinanziamento: string = "";
    // public readonly fgPignoramentiInCorso: boolean= false;
    // public readonly rataMesilePignoramento: string = "";
    // public readonly creditore: string = "";
    // public readonly rateResiduePignoramento: string = "";
    // public readonly isSupera: boolean = false
    // public readonly isNonSupera: boolean = false
    public readonly isRenditaFinanziaria: boolean = false;
    public readonly isRedditoImmobili: boolean = false;
    public readonly isRedditoAltro: boolean = false;
    public readonly descrAltroReddito: string = "";

    constructor(data: Partial<RichiestaDatiRedditoRequestModel>) {
        super();

        this.update(data);
    }
}
